import Resource from '../../models/basic.js';
import _ from 'lodash';


class ecmconfig extends Resource {
    constructor(options) {
        const opts = _.defaults({}, options, {
            baseUrl: '/mtm-gateway-api/v1/services/ecm/config',         
            idField: 'name'
        });

        super(opts);
    }
}

export default ecmconfig;